import { addPointsInText } from "../../helpers/app";
import { SuggestedPriceProps } from "../../interfaces/components";
import styles from "./suggestedPrices.module.scss";

const SuggestedPrices = ({lowPrice, mediumPrice, highPrice}: SuggestedPriceProps) => {
    return(
        <div className={styles.suggestedPricesContainer}>
            <div className={styles.box}>
                <p className={styles.label}>Min.</p>
                <p className={styles.value}>${addPointsInText(lowPrice) ?? ""}</p>
            </div>
            <div className={styles.bigBox}>
                <p className={styles.label}>Precio sugerido</p>
                <p className={styles.value}>${addPointsInText(mediumPrice) ?? ""}</p>
            </div>
            <div className={styles.box}>
                <p className={styles.label}>Max.</p>
                <p className={styles.value}>${addPointsInText(highPrice) ?? ""}</p>
            </div>
        </div>
    )
};

export default SuggestedPrices;